<template>
  <div class="mb-2 mt-2" v-if="languageCode">
    <div class="row">
      <div
        v-if="bundled"
        class="col-md-12 mb-2"
      >
        <span class="product-title">Bundled extras</span>
      </div>
      <div
        v-if="!bundled"
        class="col-md-12 mb-2"
      >
        <span class="product-title">{{ extra.name }}</span>
      </div>
    </div>
    <div
      v-for="(offerline, index) in extra.offerLines"
      :key="index"
      class="row"
    >
      <div class="col-md-12 content-list mb-2">
        <b>Offerline:</b>
        <span>{{ offerline.name }}</span>
      </div>

      <div class="col-md-12 content-list mb-2">
        <b>Quantity:</b>
        <span>{{ offerline.quantity }}</span>
      </div>

      <div
        v-if="offerline.pricePerUnit > 0"
        class="col-md-12 content-list mb-2"
      >
        <b>Price Per Unit:</b>
        <span>{{ $n(offerline.pricePerUnit, 'currency', languageCode) }}</span>
      </div>

      <div
        v-if="offerline.totalPrice > 0"
        class="col-md-12 content-list mb-2"
      >
        <b>Total:</b>
        <span><strong>{{ $n(offerline.totalPrice, 'currency', languageCode) }}</strong></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'Extra',
    props: {
        extra: {
            type: Object,
            default: null
        },
        bundled: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        languageCode () {
            return this.$store.getters['getLanguageCode']({
                identifier: this.$store.state.airport.selectedAirportId
            })
        }
    }
}
</script>
